import { render, staticRenderFns } from "./MshipsversionForm.vue?vue&type=template&id=76fdc170"
import script from "./MshipsversionForm.vue?vue&type=script&lang=js"
export * from "./MshipsversionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports